import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";

// nodes/transformNode.js
export const TransformNode = ({ id, data }) => (
  <BaseNode id={id} data={data} config={nodeConfigs.transform} />
);
